import { actionNamespace } from './defaults';
import { put, call, takeLatest } from 'redux-saga/effects';
import 'whatwg-fetch';
import $ from 'jquery';

const WP_BASE = `${process.env.REACT_APP_WP_BASE}/promos`;

const GET_WORDPRESS_REQUEST = `${actionNamespace}/GET_WORDPRESS_REQUEST`;
const GET_WORDPRESS_SUCCESS = `${actionNamespace}/GET_WORDPRESS_SUCCESS`;
const GET_WORDPRESS_ERROR = `${actionNamespace}/GET_WORDPRESS_ERROR`;

const CLEAR_WORDPRESS = `${actionNamespace}/CLEAR_WORDPRESS`;

const defaultState = {};

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_WORDPRESS_SUCCESS:
      return payload;
    case CLEAR_WORDPRESS:
      return defaultState;
    default:
      return state;
  }
};

const getHtmlById = (html, ID) => {
  try {
    const x = html.find(({ id }) => id === ID);
    return $(x).html();
  } catch (err) {
    return '';
  }
}

const apiFn = async () => {

  const res = await fetch(`${WP_BASE}/`, { credentials: 'same-origin' })
  const text = await res.text();
  const html = $.parseHTML(text);

  const headerPromos = {
    PROMO0: getHtmlById(html, 'PROMO0'),
    PROMO1: getHtmlById(html, 'PROMO1'),
    PROMO2: getHtmlById(html, 'PROMO2'),
    PROMO3: getHtmlById(html, 'PROMO3'),
    PROMO4: getHtmlById(html, 'PROMO4'),
    PROMO5: getHtmlById(html, 'PROMO5'),
  }

  const footerPromos = {
    PROMO0: getHtmlById(html, 'footerPromos')
  }

  const clubs = {
    ID1: getHtmlById(html, 'ClubID-1'),
    ID2: getHtmlById(html, 'ClubID-2'),
    ID3: getHtmlById(html, 'ClubID-3'),
    ID4: getHtmlById(html, 'ClubID-4')
  }

  return {
    headerPromos,
    footerPromos,
    clubs
  }

}


function* handleRequest(action) {
  try {
    const result = yield call(apiFn);
    yield put({ type: GET_WORDPRESS_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: GET_WORDPRESS_ERROR, payload: error });
  }
}

export function* watchForRequest() {
  yield takeLatest(GET_WORDPRESS_REQUEST, handleRequest);
}


export const actionCreators = {
  getWordpress: () => ({ type: GET_WORDPRESS_REQUEST }),
  clearWordpress: () => ({ type: CLEAR_WORDPRESS })
};

